<template>
    <div class="notice-detail-page">
        <!-- 顶部信息 -->
        <div class="page-header">
            <div class="header-info">
                <span class="info-item">
                    <span class="label">招标项目名称：</span>
                    <span class="value">{{ projectName }}</span>
                </span>
                <span class="divider"></span>
                <span class="info-item">
                    <span class="label">招标项目编号：</span>
                    <span class="value">{{ projectCode }}</span>
                </span>
            </div>
        </div>

        <!-- 详情内容 -->
        <div class="content-container">
            <div class="section-header">
                <span class="section-title">招标公告信息</span>
            </div>

            <div class="detail-table">
                <div class="detail-row">
                    <span class="detail-label">公告名称</span>
                    <span class="detail-value">{{ form.tenderNoticeName || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">关联标段</span>
                    <span class="detail-value">{{ sectionNames || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">公告发布日期</span>
                    <span class="detail-value">{{ form.noticeSendTime || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">文件获取开始时间</span>
                    <span class="detail-value">{{ form.biddingDocumentAcquisitionStartTime || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">文件获取结束时间</span>
                    <span class="detail-value">{{ form.biddingDocumentAcquisitionEndTime || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">投标截止时间</span>
                    <span class="detail-value">{{ form.bidDocumentSubmissionDeadline || '--' }}</span>
                </div>
            </div>

            <!-- 公告正文 -->
            <div class="content-block">
                <div class="content-block-title">公告正文</div>
                <div class="content-block-body" v-if="form.noticeContent" v-html="form.noticeContent"></div>
                <div class="content-block-body content-block-body--empty" v-else>暂无正文</div>
            </div>

            <!-- 附件 -->
            <div class="content-block" style="margin-top: 20px;">
                <div class="content-block-title">附件</div>
                <div class="content-block-body" v-if="attachFileList && attachFileList.length > 0" style="padding: 16px 20px; min-height: auto;">
                    <div class="attach-item" v-for="(file, fIndex) in attachFileList" :key="fIndex">
                        <span class="attach-item-name">{{ file.name }}</span>
                        <el-button type="text" size="small" @click="handleDownload(file)">下载</el-button>
                    </div>
                </div>
                <div class="content-block-body content-block-body--empty" v-else style="min-height: 80px;">暂无附件</div>
            </div>

            <!-- 底部按钮 -->
            <div class="form-footer">
                <el-button @click="handleBack">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Api_GetSemiProcessTenderNoticeDetail } from '@/api/modules/semiProcess'
import { getFileList } from '@/api/modules/base'

export default {
    name: 'AgentPublishesNoticeDetail',

    data() {
        return {
            projectName: '',
            projectCode: '',
            fileGuid: '',
            sectionList: [],
            attachFileList: [],
            form: {
                tenderNoticeName: '',
                noticeSendTime: '',
                biddingDocumentAcquisitionStartTime: '',
                biddingDocumentAcquisitionEndTime: '',
                bidDocumentSubmissionDeadline: '',
                noticeContent: ''
            }
        }
    },

    computed: {
        sectionNames() {
            return this.sectionList.map(s => s.bidSectionName).join('、')
        }
    },

    created() {
        this.projectName = this.$route.query.projectName || ''
        this.projectCode = this.$route.query.projectCode || ''
        this.getDetail()
    },

    methods: {
        getDetail() {
            const tenderNoticeCode = this.$route.query.tenderNoticeCode
            if (!tenderNoticeCode) {
                this.$message.error('缺少公告编号参数')
                return
            }
            Api_GetSemiProcessTenderNoticeDetail({
                projectCode: this.projectCode,
                tenderNoticeCode: tenderNoticeCode
            }).then(res => {
                if (res.code === 200 && res.data) {
                    const data = res.data
                    this.form.tenderNoticeName = data.tenderNoticeName || ''
                    this.form.noticeSendTime = data.noticeSendTime || ''
                    this.form.biddingDocumentAcquisitionStartTime = data.biddingDocumentAcquisitionStartTime || ''
                    this.form.biddingDocumentAcquisitionEndTime = data.biddingDocumentAcquisitionEndTime || ''
                    this.form.bidDocumentSubmissionDeadline = data.bidDocumentSubmissionDeadline || ''
                    this.form.noticeContent = data.noticeContent || ''
                    this.sectionList = data.sections || []
                    this.fileGuid = data.fileGuid || ''
                    // 获取附件列表
                    if (data.fileGuid) {
                        this.getAttachFileList(data.fileGuid)
                    }
                }
            }).catch(() => {
                this.$message.error('获取详情失败')
            })
        },

        // 获取附件列表
        getAttachFileList(fileGuid) {
            getFileList(fileGuid).then(res => {
                if (res.code === 200 && res.data) {
                    this.attachFileList = (res.data || []).map(file => ({
                        name: file.fileName || file.name || '附件',
                        fileUrl: file.fileUrl || '',
                        fileSize: file.fileSize || 0,
                        fileId: file.fileId || ''
                    }))
                }
            }).catch(() => {
                this.attachFileList = []
            })
        },

        // 下载附件
        handleDownload(file) {
            if (file.fileUrl) {
                window.open(file.fileUrl, '_blank')
            } else {
                this.$message.warning('文件链接不存在')
            }
        },

        handleBack() {
            this.$router.back()
        }
    }
}
</script>

<style lang="less" scoped>
.notice-detail-page {
    background: #f5f5f5;
    min-height: 100vh;
    padding: 20px;
}

.page-header {
    background: #fff;
    padding: 16px 20px;
    margin-bottom: 12px;
}

.header-info {
    display: flex;
    align-items: center;
}

.info-item {
    font-size: 14px;
}

.label {
    color: #666;
}

.value {
    color: #333;
}

.divider {
    width: 1px;
    height: 14px;
    background: #ddd;
    margin: 0 20px;
}

.content-container {
    background: #fff;
    padding: 20px;
}

.section-header {
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
}

.section-title {
    font-size: 15px;
    font-weight: 500;
    color: #333;
}

// 基本信息表格
.detail-table {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 20px;
}

.detail-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;

    &:last-child {
        border-bottom: none;
    }
}

.detail-label {
    width: 160px;
    min-width: 160px;
    padding: 14px 16px;
    background: #fafafa;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: flex-start;
    border-right: 1px solid #ebeef5;
    box-sizing: border-box;
}

.detail-value {
    flex: 1;
    padding: 14px 16px;
    color: #303133;
    font-size: 14px;
    word-break: break-all;
    display: flex;
    align-items: flex-start;

    &--empty {
        color: #c0c4cc;
    }
}

// 公告正文区块
.content-block {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
}

.content-block-title {
    padding: 14px 20px;
    background: #fafafa;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 1px solid #ebeef5;
}

.content-block-body {
    padding: 24px 28px;
    color: #303133;
    font-size: 15px;
    line-height: 2;
    min-height: 200px;
    word-break: break-all;

    &--empty {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #c0c4cc;
    }

    // 富文本内容样式
    /deep/ p {
        margin: 0 0 12px;
        text-indent: 2em;

        &:last-child {
            margin-bottom: 0;
        }
    }

    /deep/ h1, /deep/ h2, /deep/ h3, /deep/ h4, /deep/ h5, /deep/ h6 {
        margin: 20px 0 12px;
        text-indent: 0;
        font-weight: 600;

        &:first-child {
            margin-top: 0;
        }
    }

    /deep/ h1 { font-size: 22px; }
    /deep/ h2 { font-size: 20px; }
    /deep/ h3 { font-size: 18px; }
    /deep/ h4 { font-size: 16px; }

    /deep/ ul, /deep/ ol {
        padding-left: 2em;
        margin: 8px 0;

        li {
            margin-bottom: 6px;
            text-indent: 0;
        }
    }

    /deep/ table {
        border-collapse: collapse;
        width: 100%;
        margin: 12px 0;

        td, th {
            border: 1px solid #e8e8e8;
            padding: 8px 12px;
            text-indent: 0;
            vertical-align: middle;
        }

        th {
            background: #fafafa;
            font-weight: 600;
        }
    }

    /deep/ img {
        max-width: 100%;
        height: auto;
    }

    /deep/ blockquote {
        margin: 12px 0;
        padding: 10px 16px;
        border-left: 4px solid #e8e8e8;
        background: #fafafa;
        text-indent: 0;
    }

    /deep/ strong {
        font-weight: 600;
    }

    /deep/ em {
        font-style: italic;
    }

    /deep/ a {
        color: #409eff;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
}

// 附件列表
.attach-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px dashed #ebeef5;

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    &:first-child {
        padding-top: 0;
    }
}

.attach-item-name {
    flex: 1;
    color: #303133;
    font-size: 14px;
    word-break: break-all;
}

.form-footer {
    padding-top: 24px;
    margin-top: 24px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: center;
    gap: 12px;
}
</style>
